export default __webpack_public_path__ + "static/media/640_dummy2016-weinhandel01-de.91a041fa.png";